// @ts-strict-ignore
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from '@angular/core';
import { NgButtonComponent } from '@fc-shared/ui/buttons/ng-button';
import { IconComponent } from '@fc-shared/ui/icon/icon.component';
import { NgClass } from '@angular/common';
import { AppIconsType } from '@fc-shared/ui/icon/icons';

@Component({
  selector: 'fc-notification',
  template: `
    <div
      class="fc-anim-slide-up-in shadow-notification flex flex-row gap-16 items-center justify-between p-8 rounded-2xl text-base w-full md:w-fit min-w-300 m-8 md:m-0 bg-white"
      [class.fc-anim-slide-down-out]="leaving()"
      (animationend)="onAnimationEnd($event)"
    >
      <div
        class="flex size-38 items-center justify-center rounded-full p-4"
        [ngClass]="statusColor"
      >
        <fc-icon
          [icon]="statusIcon"
          [color]="statusIconColor"
          [size]="20"
        ></fc-icon>
      </div>
      <div class="text-base flex-1">
        <ng-content></ng-content>
        {{ message() }}
      </div>
      @if (action()) {
        <ng-button
          variant="icon"
          (click)="action()()"
          icon="icon-info-circle"
        />
      }
      @if (closeable()) {
        <ng-button variant="icon" (click)="destroy()" icon="icon-close" />
      }
    </div>
  `,
  imports: [NgButtonComponent, IconComponent, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationComponent {
  message = input<string>();
  action = input<() => void>(null);
  type = input<'success' | 'error' | 'warning'>('success');
  closeable = input<boolean>(false);
  ondestroy = output<void>();
  leaving = signal(false);

  get statusColor() {
    switch (this.type()) {
      case 'success':
        return 'bg-primary-100';
      case 'error':
        return 'bg-error-50';
      case 'warning':
        return 'bg-warning-50';
    }
  }

  get statusIconColor() {
    switch (this.type()) {
      case 'success':
        return 'primary500';
      case 'error':
        return 'error500';
      case 'warning':
        return 'warning500';
    }
  }

  get statusIcon(): AppIconsType {
    switch (this.type()) {
      case 'success':
        return 'icon-info-circle';
      case 'error':
        return 'icon-info-circle';
      case 'warning':
        return 'icon-info-circle';
    }
  }

  destroy() {
    this.leaving.set(true);
  }

  onAnimationEnd(event: AnimationEvent) {
    if (event.animationName === 'fc-slide-down-out') {
      this.ondestroy.emit();
    }
  }
}
